import styled from 'styled-components';
import ArrowIcon from '@/assets/mo/arrow-dropdown.svg?react';
import { useQuery } from '@tanstack/react-query';
import { fetchDashboardData, DashboardResponse } from '@/api/dashboard';

const ExpertStatsCard = () => {
  const { data, isPending } = useQuery<DashboardResponse>({
    queryKey: ['dashboardData'],
    queryFn: fetchDashboardData,
  });
  return (
    <CardWrapper>
      <TopBadge>
        <Badge>성과로 증명하는 전문가, 올받음</Badge>
      </TopBadge>
      <RowGroup>
        <InfoGroup>
          <LabelBadge>선임</LabelBadge>
          <InfoTextWrapper>
            <InfoText>
              {' '}
              {isPending ? '...' : `${data?.totalUserCount?.toLocaleString()}건`}
            </InfoText>
            <ArrowIcon />
          </InfoTextWrapper>
        </InfoGroup>
        <InfoGroup>
          <LabelBadge>상담</LabelBadge>
          <InfoTextWrapper>
            <InfoText> {isPending ? '...' : `${data?.customerScore?.toLocaleString()}건`}</InfoText>
            <ArrowIcon />
          </InfoTextWrapper>
        </InfoGroup>
      </RowGroup>
    </CardWrapper>
  );
};

export default ExpertStatsCard;

const CardWrapper = styled.div`
  display: flex;
  height: 60px;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--table-BG-table_bg02_hov, #f0f3fe);
`;

const TopBadge = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 99px;
`;

const Badge = styled.span`
  color: var(--gray-ui_gray03, #3a3a3a);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const RowGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const InfoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LabelBadge = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 99px;
  background: #fff; // 필요에 따라 색상 조정

  color: var(--gray-ui_gray04, #6f6f6f);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const InfoTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const InfoText = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;

  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.24px;
  margin-right: 4px;
`;
